<template>
  <common-dialog ref="dialog" width="650px" title="批量录入订单" id-key="id">
    <template slot="form">
      <el-alert type="warning" show-icon :closable="false" title="免责说明"
        description="由于省市区地址复杂，批量导入地址后，请您务必校验地址省市区是否正确，本软件不承担因个人未校验导致物流配送错误的问题。">
      </el-alert>
      <div style="margin-top: 20px;">
        <div class="upload-box">
          <import-file w="200px" size="small" upload-url="api.import" text="上传 手工订单模板" @on-uploaded="uploaded" />
          <el-button class="temp-btn" type="text">下载模板</el-button>
          <el-button class="error-btn" type="text">上传失败，点击查看</el-button>
        </div>
        <div class="upload-box">
          <import-file w="200px" size="small" upload-url="api.import" text="上传 批量关联订单模板" @on-uploaded="uploaded" />
          <el-button class="temp-btn" type="text">下载模板</el-button>
        </div>
      </div>
    </template>
    <template slot="footer">
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';
import importFile from "@/components/common/files/importFile"

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
  },
  data() {
    return {
      data: {
        id: 0,
        用户名: '',
      },
    };
  },
  methods: {
    uploaded(res) {
      console.log("uploaded", res);
      // this.$refs.dialog.isChange = false;
      // if (res.Code != 0) {
      //   if (res.Code == 2) {
      //     this.detailUrl = res.Data;
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // } else {
      //   this.$emit("upload-success");
      //   this.detailUrl = "";
      //   this.close(true);
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-box {
  border: 1px solid #EBEEF5;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .upload-btn {
    width: 200px;
  }

  .temp-btn {
    color: #9d9d9d;
    margin: 0;
    font-size: 14px;
    margin-top: 5px;
  }

  .error-btn {
    color: #F56C6C;
    margin: 0;
    font-size: 14px;
    display: none;
  }
}

.upload-box+.upload-box {
  margin-top: 10px;
}
</style>